import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TypeTableMinMax } from '../models/TypeTableMinMax';
import { TR } from '../models/TR';
import { Step3 } from '../../../../shared/models/component-messages/mapaIN/step3';
import { ArrayPopTools } from '../../../../shared/services/array-pop-tools';

@Component({
  selector: 'app-type-table-min-max',
  templateUrl: './type-table-min-max.component.html'
})
export class TypeTableMinMaxComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeTableMinMax';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	
	@Input() tabCarMinMax: TypeTableMinMax;

  public step3 = new Step3();

  constructor() { }

  public ngOnInit() {
  }
  
  
  addtR(){
		this.tabCarMinMax.tr.push(new TR());
	}
  
  removetR(i){
    ArrayPopTools.pop(this.tabCarMinMax.tr, i, this.parentForm, this.getUid());
	}
  

  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
  
  
}

